import { useState } from 'react'

import { gql, useMutation } from '@apollo/client'
import AskUserConfirmation from 'Root/App/Dialog/ask-user-confirmation'

import RemoveButton from './Row/remove-button'
import RemoveUserAuthorizationAlert from './Row/remove-user-auth-alert'
import GroupAuthSelect from './group-auth-select'
import GroupInfo from './group-info'

export interface RemoveAuthorizationGroup {
  removeAuthorizationGroup: boolean
}

export interface RemoveAuthorizationgGroupVariables {
  id: string
}

const REMOVE_AUTHORIZATION_GROUP = gql`
  mutation RemoveAuthorizationGroup($id: ID!) {
    removeAuthorizationGroup(id: $id)
  }
`

const GroupAuthorizationRowItem = ({ groupAuth, elementId }) => {
  const groupAuthId = groupAuth.id || ''
  const groupAuthValue = groupAuth.value || ''
  const groupName = groupAuth.group?.name || ''
  const groudId = groupAuth.group?.id || ''
  const groudIdentifier = groupAuth.group?.identifier || ''
  const groupUsersCount = groupAuth.group?.usersCount || 0
  const [openRemoveDialog, setOpenRemoveDialog] = useState(false)
  const [mutate, { loading }] = useMutation<
    RemoveAuthorizationGroup,
    RemoveAuthorizationgGroupVariables
  >(REMOVE_AUTHORIZATION_GROUP, {
    refetchQueries: ['GetElementAuthorizationForGroups'],
  })

  const handleAuthorizationRemove = async () => {
    await mutate({
      variables: {
        id: groupAuthId,
      },
    })

    setOpenRemoveDialog((openDialog) => !openDialog)
  }

  const onCloseFn = !loading
    ? () => setOpenRemoveDialog((openRemoveDialog) => !openRemoveDialog)
    : () => null

  return (
    <div
      className="flex flex-col justify-between gap-3 p-3 sm:flex-row sm:gap-1"
      key={groupAuthId}
      role="listitem"
    >
      <GroupInfo
        name={groupName}
        identifier={groudIdentifier}
        usersCount={groupUsersCount}
        imgClassName="my-auto w-10 h-10 rounded-md"
      />

      <div className="flex flex-row gap-1">
        <GroupAuthSelect
          elementId={elementId}
          authValue={groupAuthValue}
          groupId={groudId}
        />
        <RemoveButton onRemoveCallback={() => setOpenRemoveDialog(true)} />
      </div>

      {openRemoveDialog && (
        <AskUserConfirmation openDialog={openRemoveDialog} onClose={onCloseFn}>
          <RemoveUserAuthorizationAlert
            onConfirm={handleAuthorizationRemove}
            onClose={onCloseFn}
            isRemoving={loading}
          />
        </AskUserConfirmation>
      )}
    </div>
  )
}

export default GroupAuthorizationRowItem
